import React, {useContext} from 'react';
import {useStateWithCallback} from 'polyphony/hooks';
import {withExplicitProps} from 'polyphony/hoc';
import {prefixCSS} from 'polyphony/css';
import {HSLColor} from 'polyphony/colors';

const SegContext = React.createContext({setValue: () => undefined, currentValue: undefined, color: 'cyan'});

const SegmentedControl = ({defaultValue, onChange, color, containerStyle, textStyle, style, stackOptions, ...props}) => {
    const [currentValue, setValue] = useStateWithCallback(defaultValue, onChange);
    return (
        <SegContext.Provider value={{stackOptions, setValue, currentValue, color: color || 'cyan', containerStyle, textStyle}}>

            <div {...props} style={{...style, ...prefixCSS({display: 'flex', flexWrap: 'nowrap',
                                    flexDirection: stackOptions ? 'column' : 'row'})}} />
        </SegContext.Provider>
    );
};

SegmentedControl.displayName = 'SegmentedControl';

function callableStyle(s, state) {
    if (!s) return {};

    if (typeof s === 'function') {
        return s(state);
    }

    return s;
}

const styles = {
    optionContainer: prefixCSS({
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        boxSizing: 'border-box'
    }),
    option: prefixCSS({
        pointerEvents: 'none',
        userSelect: 'none',
        textAlign: 'center',
        width: '100%',
        padding: 10,
        boxSizing: 'border-box',
        fontWeight: 800
    })
};

SegmentedControl.Option = withExplicitProps(({title, value}) => {
    const {stackOptions, setValue, currentValue, color, containerStyle, textStyle} = useContext(SegContext);
    const isSelected = currentValue === value;
    const _color = HSLColor.parseString(color);
    const backgroundColor = (isSelected ? _color.darken(10) : _color).toHslString();

    return <div onClick={() => setValue(value)} style={{pointerEvents: isSelected ? 'none' : 'initial',
                                                        cursor: isSelected ? 'normal' : 'pointer',
                                                        backgroundColor,
                                                        ...styles.optionContainer,
                                                        ...callableStyle(containerStyle, isSelected),
                                                        width: stackOptions ? '100%' : undefined}}>
                <div style={{...styles.option, ...callableStyle(textStyle, isSelected)}}>
                    {title}
                </div>
           </div>;
}, ['title', 'value']);

SegmentedControl.Option.displayName = 'SegmentedControl.Option';

export default SegmentedControl;

